import * as React from "react";

class MetricPopover extends React.Component<any, any> {
  render() {
    return (
      <div className="metric-popover">
        <p>
          <strong>Metrics:</strong> Quantifiable measures of marketing
          performance.
        </p>
      </div>
    );
  }
}

export default MetricPopover;



// WEBPACK FOOTER //
// ./client/modules/ReportForm/components/StageOne/ReportStructure/MetricPopover.tsx